import parse from 'html-react-parser';
import { SsqImages } from 'images/SsqImages';
import { i18ntrans, tc } from 'language/i18nkey';
import { useRcentSearch } from 'mainpage/toparea/srchinput/useRcentSearch';
import { ISearchedCategoryExt, useRelatedCategory } from 'mainpage/toparea/srchinput/useRelatedCategory';
import { SrchType, useZstdSrch } from 'mainpage/toparea/srchinput/useZstdSrch';
import * as React from 'react';
import { fontFamilyBold, fontFamilyMedium, fonts } from 'style/fonts';
import styled from 'styled-components';
import { getHighlightedTextFromHtml } from 'util/commonUtils';
import hirosmall from './hiro-small.png';
import { ToggleBtn } from './ToggleBtn';
//import {useApiNewSrch} from './useApiNewSrch';
import { DOC_TYPE } from 'definitions/DocType';
import { useHandleSrch } from 'header/header/srchinput/useHandleSrch';
import {
  ALL_DOC_TYPES,
  DOWNLOAD_DOC_TYPES,
  NEWS_EVENT_DOC_TYPES,
  QNA_DOC_TYPES,
  SAMPLE_DOC_TYPES,
} from 'search3/search-tabs';
import { isLang } from 'services';
import { ssqutil } from 'util/ssqutil';
import { InputAssistAutoQuery } from './InputAssistAutoQuery';
import { InputAssistKnowledge } from './InputAssistKnowledge';
import { InputAssistPopQuery } from './InputAssistPopQuery';
import { InputAssistSrchV3 } from './InputAssistSrchV3';

type Props = {
  refAssist: React.MutableRefObject<HTMLDivElement>;
};
export const InputAssistFill = (props: Props) => {
  const t = i18ntrans.tmain;

  const [recents] = useRcentSearch();
  const { inputTmp, setInput, srchType, isAiMode, setIsAiMode } = useZstdSrch();

  //const relateds = useRelatedSuggest(input);
  //const relatedCategory = useRelatedCategory(srchType === SrchType.ALL ? input : '');
  const relatedCategory = useRelatedCategory('');
  //const newSearch = useApiNewSrch();
  const { handleSrch: newSearch } = useHandleSrch();
  // 입력 2자 이상이면 최근·인기 검색어 숨김
  const showSuggest = (inputTmp?.trim().length ?? 0) < 2;
  return (
    <Body>
      <Content ref={props.refAssist}>
        <ContentBody>
          {showSuggest && !!recents?.length && (
            <Recent>
              {t('I18N_MAIN_SEARCH_RECENT_SEARCH')}

              {recents?.map((recent, index) => (
                <div
                  key={index}
                  onClick={() => {
                    setInput(recent);
                    newSearch(recent);
                  }}>
                  <RecentBtn>
                    <img src={SsqImages.common.icon.recentSearchIcon()} />
                    <span>{recent}</span>
                  </RecentBtn>
                </div>
              ))}
            </Recent>
          )}

          {/* <Related>
            {t('I18N_MAIN_SEARCH_RESULT_RELATION')}

            {relateds.map((item, index) => (
              <div
                key={index}
                onClick={() => {
                  setInput(item.suggestName);
                  newSearch(item.suggestName);
                }}>
                <ReleatedBtn>
                  <img src={SsqImages.common.icon.relatedSuggestResultIcon()} />
                  <span>{item.highlightedResultElement}</span>
                </ReleatedBtn>
              </div>
            ))}
          </Related> */}

          <InputAssistAutoQuery />

          {showSuggest && <InputAssistPopQuery />}

          {srchType === SrchType.KNOWLEDGE && <InputAssistKnowledge />}
          {srchType === SrchType.QNA && (
            <InputAssistSrchV3 docTypes={QNA_DOC_TYPES as DOC_TYPE[]} showDocType={false} />
          )}
          {srchType === SrchType.SAMPLE && <InputAssistSrchV3 docTypes={SAMPLE_DOC_TYPES as DOC_TYPE[]} />}
          {srchType === SrchType.NEWS_EVENT && <InputAssistSrchV3 docTypes={NEWS_EVENT_DOC_TYPES as DOC_TYPE[]} />}
          {srchType === SrchType.DLCENTER && <InputAssistSrchV3 docTypes={DOWNLOAD_DOC_TYPES as DOC_TYPE[]} />}
          {srchType === SrchType.ALL && <InputAssistSrchV3 docTypes={ALL_DOC_TYPES as DOC_TYPE[]} />}

          {false && srchType === SrchType.ALL && (
            <Category>
              <CategoryTitle>{t('I18N_MAIN_SEARCH_RESULT_CATEGORY')}</CategoryTitle>
              {relatedCategory?.items?.map((item: ISearchedCategoryExt, index) => (
                <div
                  key={index}
                  onClick={() => {
                    window.open(`/product/category/${item.id}`, '_self');
                  }}>
                  <CategoryBtn>
                    <img src={SsqImages.common.icon.searchResultImg()} />
                    <span>{item.highlightedResultElement}</span>
                  </CategoryBtn>
                  {/* todo: 모델추가 */}
                  <RelatedModel>
                    {item.itemModels.map((model, i) => (
                      <span key={i}>{parse(getHighlightedTextFromHtml(model))}</span>
                    ))}
                  </RelatedModel>
                </div>
              ))}
            </Category>
          )}
        </ContentBody>
        {srchType === SrchType.ALL && (
          <AiSrch>
            <ToggleBtn onClick={() => setIsAiMode(!isAiMode)} isOn={isAiMode} sm={true} />
            &nbsp; {tc('i18n_mobile_ai_mode_use')} &nbsp;
            {isAiMode && (
              <span>
                <img src={hirosmall} />
              </span>
            )}
          </AiSrch>
        )}
      </Content>
    </Body>
  );
};
const ContentBody = styled.div`
  flex-grow: 1;
  //overflow-y: auto;;
`;
const AiSrch = styled.div`
  border-top: 1px solid #dde2e9;
  padding: 1.3rem 1.6rem;
  font-size: 1.3rem;
  display: flex;
  align-items: center;
  color: #909fb7;
  overflow: visible;

  & > span {
    img {
      position: relative;
      top: -2.1rem;
      margin-bottom: -3.8rem;
    }
  }
`;

const RelatedModel = styled.div`
  display: flex;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;

  ${fonts.medium};
  font-size: 13px;
  line-height: 19px;
  display: flex;
  align-items: center;
  overflow: hidden;
  gap: 0.3rem;

  span {
    padding: 0.5rem 1rem 0.6rem 1rem;

    background: rgba(255, 255, 255, 0.3);
    border: 1px solid #cdd9ea;
    height: 1.6rem;
    border-radius: 100px;

    ${fontFamilyMedium};
    font-size: 1rem;
    display: flex;
    align-items: center;
    flex-shrink: 0;

    .search_highlight {
      color: #909fb7;
    }
  }
`;

const CategoryBtn = styled.button`
  margin-right: 1rem;
  font-size: 1.3rem;
  text-align: left;
  line-height: 3.2rem;
  ${fonts.bold};
  color: #2a2c2f;
  display: flex;
  align-items: center;
  flex-shrink: 0;

  img {
    vertical-align: middle;
  }
`;
const CategoryTitle = styled.div`
  box-sizing: border-box;
  border-top: 1px solid #dde2e9;
  width: 100%;
  padding: 0.8rem;
  text-align: left;
  font-size: 1rem;
  color: #909fb7;
`;
const Category = styled.div`
  margin-bottom: 0.8rem;
`;

const Related = styled.div`
  box-sizing: border-box;
  border-top: 1px solid #dde2e9;
  width: 100%;
  padding: 0.8rem;
  text-align: left;
  font-size: 1rem;
  color: #909fb7;
`;

const ReleatedBtn = styled.button`
  margin-right: 1rem;
  font-size: 1.3rem;
  text-align: left;
  line-height: 3.2rem;
  ${fontFamilyBold};
  color: #2a2c2f;
  display: flex;
  align-items: center;
  flex-shrink: 0;

  img {
    vertical-align: middle;
  }
`;

const RecentBtn = styled.button`
  margin-right: 1rem;
  font-size: 1.3rem;
  text-align: left;
  line-height: 3.2rem;
  ${fontFamilyMedium};
  color: #2a2c2f;
  display: flex;
  align-items: center;
  flex-shrink: 0;

  img {
    vertical-align: middle;
  }
`;

const Recent = styled.div`
  box-sizing: border-box;
  border-top: 1px solid #dde2e9;
  width: 100%;
  padding: 0.8rem;
  text-align: left;
  font-size: 1rem;
  color: #909fb7;

  /* 최근 검색어 행: 호버 시 패널 끝까지 꽉 찬 하이라이트 (컨테이너 좌우 패딩 0.8rem 상쇄) */
  & > div {
    margin: 0 -0.8rem;
    padding: 0 0.8rem;
    cursor: pointer;

    &:hover {
      background: #407edb1a;
    }
  }
`;

const Body = styled.div`
  position: relative;
  flex: 1;
  min-height: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  z-index: 1;
`;

const Content = styled.div`
  color: #2a2c2f;
  display: flex;
  flex: 1;
  min-height: 0;
  flex-direction: column;
  position: relative;
  background-color: white;
  //border-radius: 0 0 4px 4px;
  //box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.1);
  overflow-y: auto;
`;
